import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'antd'

class StatusStyle extends Component {
    _mapStatus = () => {
        const {status, note, processing_at} = this.props
        const startTime = new Date(processing_at)
        const endTime = new Date()
        const processingTime = endTime - startTime
        const hours = Math.floor(processingTime / (1000 * 60 * 60))
        const minutes = Math.floor((processingTime % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((processingTime % (1000 * 60)) / 1000)
        const formattedTime = `${!!hours ? String(hours).padStart(2, '0') + 'h' : ''} ${!!minutes ? String(minutes).padStart(2, '0') + 'm' : ''} ${!!seconds ? String(seconds).padStart(2, '0') + 's' : ''}`

        if (!status) {
            return null
        }

        let output = ''
        switch (status) {
            case 'error':
            case 'archived':
                output = <span className="badge badge-danger badge-pill">{status}</span>
                break
            case 'fully-done':
            case 'done':
            case 'printed':
            case 'completed':
                output = <span className="badge badge-success badge-pill">{status}</span>
                break
            case 'pending':
            case 'retry':
            case 'waiting':
                output = <span
                    className="badge badge-info badge-pill progress-bar-animated progress-bar-striped">{status}</span>
                break
            case 'processing':
                output = (!hours && !minutes && !seconds) ?
                    <span className="badge badge-primary badge-pill progress-bar-animated progress-bar-striped">{status}</span> :
                    <Tooltip title={formattedTime} placement='topLeft'>
                        <span className="badge badge-primary badge-pill progress-bar-animated progress-bar-striped">{status}</span>
                    </Tooltip>
                break
            case 'on-hold':
            case 'unprinted':
            case 'pushed':
            case 'disabled':
                output = <span className="badge badge-secondary badge-pill">{status}</span>
                break
            case 'review':
                output = <span
                    className="badge badge-warning badge-pill progress-bar-animated progress-bar-striped">{status}</span>
                break
            case 'cancelled':
                output = note ?
                    <Tooltip title={note} placement='top'><span className="badge badge-dark badge-pill">{status}</span></Tooltip>
                    : <span className="badge badge-dark badge-pill">{status}</span>
                break
            case 'free':
                output = <span
                    className="badge badge-primary badge-pill">{status}</span>
                break
            case 'printing':
                output = <span
                    className="badge printing badge-pill">{status}</span>
                break
            case 'transferring':
                output = <span
                    className="badge transferring badge-pill">{status}</span>
                break
            case 'transferred':
                output = <span
                    className="badge transferred badge-pill">{status}</span>
                break
            case 'confirmed':
                output = <span
                    className="badge confirmed badge-pill">{status}</span>
                break
            case 'wait_to_sew':
                output = <span
                    className="badge wait-sew badge-pill progress-bar-animated progress-bar-striped">{status}</span>
                break
            case 'sewing':
                output = <span
                    className="badge sewing badge-pill">{status}</span>
                break
            case 'cancel-ship':
                output = <span
                    className="badge cancel-ship badge-pill">{status}</span>
                break
            case 'moved':
                output = <span
                    className="badge moved badge-pill">{status}</span>
                break
            default:
                output = <span className={`badge ${status || 'other'} badge-pill`}>{status}</span>
        }

        return output
    }

    render() {
        const status = this._mapStatus()

        return (
            <Fragment>
                {status}
            </Fragment>
        )
    }
}

StatusStyle.defaultProps = {
    note: ''
}

StatusStyle.propTypes = {
    status: PropTypes.string,
    note: PropTypes.string
}

export default StatusStyle
